import type { Dispatch, SetStateAction } from "react";
import type { FuelPlan } from "./services";
import SingleTractorForm from "./single-tractor-form";

interface FormLayoutProps {
  setFuelPlan: Dispatch<SetStateAction<FuelPlan | null>>;
}

const FormLayout = ({ setFuelPlan }: FormLayoutProps) => {
  return (
    <div className="flex flex-col h-full flex-shrink-0 overflow-hidden">
      <div className="flex-1 overflow-y-auto">
        <SingleTractorForm setFuelPlan={setFuelPlan} />
      </div>
    </div>
  );
};

export default FormLayout;
